// extracted by mini-css-extract-plugin
export default {"container":"FPSpinner_container__+quSM","lds":"FPSpinner_lds__xRHgu","lds-facebook":"FPSpinner_lds-facebook__ZQn0C"};